"use strict";var __importDefault=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(exports,"__esModule",{value:!0}),exports.LoginInfoContents=void 0;const jsx_runtime_1=require("react/jsx-runtime"),styled_components_1=__importDefault(require("styled-components")),TranslationContext_1=require("../context/TranslationContext"),ContentRoot=styled_components_1.default.div`
  display: flex;
  width: 50%;
  align-items: center;
  justify-content: center;
`,LoginInfoContentsDiv=styled_components_1.default.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`,TitleDiv=styled_components_1.default.div`
  padding: 10px;
  box-sizing: border-box;
  color: #4b8cff;
  text-align: center;
  font-family: Poppins;
  display: flex;
  flex-direction: column;
  gap: 6px;

  .title {
    font-size: 2em;
    font-weight: 400;
  }

  .sub-title {
    font-size: 3em;
    color: #4b8cff;
    font-weight: 800;
  }

  /* .sub-title {
    font-size: clamp(14px, 1.2em, 20px);
    color: #4B8CFF;
  } */
`,VideoDiv=styled_components_1.default.video`
  /* padding: 10px 30px; */
  box-sizing: border-box;
  width: 100%;
  border-radius: 30px;
  border: 20px solid white;
`,FooterDiv=styled_components_1.default.div`
  color: #4b8cff;
  align-items: center;
  text-align: center;
  margin-top: 30px;

  .infoText {
    font-family: Poppins;
    font-size: 1rem;
    font-weight: 300;
    font-size: clamp(18px, 1.2em, 32px);
    line-height: 30px;

    .emphasis {
      margin: 0 8px;
      font-weight: 800;
    }
  }
`,StyledUl=styled_components_1.default.ul`
  color: #777777;
  display: flex;
  text-align: center;
  align-items: center;

  /* flex-wrap: wrap; */
  font-family: Poppins;
  font-size: clamp(14px, 0.6em, 20px);
  font-weight: 700;

  li {
    /* padding: 0; */
    font-weight: 800;
    margin: 0 12px;
  }
`,LoginInfoContents=()=>{const{t:e}=(0,TranslationContext_1.useTranslationContext)();return(0,jsx_runtime_1.jsx)(ContentRoot,{children:(0,jsx_runtime_1.jsxs)(LoginInfoContentsDiv,{children:[(0,jsx_runtime_1.jsxs)(TitleDiv,{children:[(0,jsx_runtime_1.jsxs)("div",{className:"title",children:[e("All in One")," "]}),(0,jsx_runtime_1.jsx)("div",{className:"sub-title",children:e("AI Video Generator")})]}),(0,jsx_runtime_1.jsx)(VideoDiv,{autoPlay:!0,muted:!0,loop:!0,children:(0,jsx_runtime_1.jsx)("source",{src:"https://renew.deepbrainai.io/renewal_resources/videos/241023_studios3.3_real_final.mp4"})}),(0,jsx_runtime_1.jsx)(FooterDiv,{children:(0,jsx_runtime_1.jsx)("div",{className:"ul-container",children:(0,jsx_runtime_1.jsxs)(StyledUl,{children:[(0,jsx_runtime_1.jsx)("li",{children:e("Free Welcome Credit")}),(0,jsx_runtime_1.jsx)("li",{children:e("Easy to Use")}),(0,jsx_runtime_1.jsx)("li",{children:e("No Credit Card Required")})]})})})]})})};exports.LoginInfoContents=LoginInfoContents;